import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "components/shared/toast/toast";
import { USER } from "services/apiEndpoints";
import { privateDelete, privateGet } from "services/privateRequest";
import { makeQueryString } from "utils/utils";

const initialState = {
    users: [],
    selectedUser: null,
    userModalOpen: false,
    isFetching: false,
    allUsers: [],
    pageNumber: 1,
    pageSize: 10,
    totalCount: 0,
    filters: {
        selectedTeam: { label: "", value: "" },
    }
}

export const getUsersData = createAsyncThunk("users/getUsersData", async (payload, { rejectWithValue, dispatch, signal }) => {

    try {
        const queryString = makeQueryString(USER, payload);

        const { data } = await privateGet(queryString, { signal });

        dispatch(setPageNumber(payload.pageNumber));
        dispatch(setPageSize(payload.limit));

        return {
            user: data?.data?.responses || [],
            totalCount: data?.data?.totalResponses || 0,
        };
    } catch (error) {
        rejectWithValue(error);
        return error;
    }


})

export const getAllUsersData = createAsyncThunk("users/getAllUsersData", async () => {
    // api call here
})

export const deleteUser = createAsyncThunk("entity/deleteUser", async (id, { dispatch }) => {
    await privateDelete(USER, id)
    dispatch(getUsersData())
    toast.success("User deleted successfully")
})

const userSlice = createSlice({
    name: "users",
    initialState,
    reducers: {
        setPageNumber: (state, action) => {
            state.pageNumber = action.payload;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
            state.pageNumber = 1;
        },
        setIsFetching: (state, action) => {
            state.isFetching = action.payload
        },
        setSelectedUser: (state, action) => {
            state.selectedUser = action.payload
            state.userModalOpen = !!action.payload
        },
        setUserModalOpen: (state, action) => {
            state.userModalOpen = action.payload
        },
        setSelectedTeamFilter: (state, action) => {
            if (!action.payload) {
                state.filters.selectedTeam = { label: "", value: "" };
            }
            else { state.filters.selectedTeam = action.payload; }
        },

    },
    extraReducers: {
        [getUsersData.pending]: (state, action) => {
            state.isFetching = true
        },
        [getUsersData.fulfilled]: (state, action) => {
            state.users = action.payload.user
            state.totalCount = action.payload.totalCount
            state.isFetching = false
        },
        [getUsersData.rejected]: (state, action) => {
            state.isFetching = false
        },
        [getAllUsersData.fulfilled]: (state, action) => {
            state.allUsers = action.payload.allUsers
        },
    }
})

export default userSlice.reducer
export const { setIsFetching, setSelectedTeamFilter, setSelectedUser, setUserModalOpen, setPageNumber, setPageSize } = userSlice.actions